import Container from '@/components/layout/Container';
import ConditionalWrapper from '@/components/layout/ConditionalWrapper';
import InnerSection from './InnerSection';

/**
 * The VideoWayfinder component renders a section containing a video and a
 * content block with a title, content, and optional link. Notably, the video can
 * be portrait or landscape, and can be aligned left or right of the content block.
 */
const VideoWayfinder = ({
  block,
  background_color,
  block_color,
  entry_uid,
  position
}) => {
  const {
    video_first,
    title,
    content,
    link,
    vimeo_url,
    youtube_url,
    portrait_video
  } = block.video;

  return (
    <section id={`${entry_uid}_${position}`} data-name="wayfinder-video">
      <Container fullpage={false}>
        <ConditionalWrapper
          condition={portrait_video}
          className="mx-auto max-w-[1100px]"
        >
          <InnerSection
            videoFirst={video_first}
            vimeoUrl={vimeo_url}
            youtubeUrl={youtube_url}
            portraitVideo={portrait_video}
            backgroundColor={background_color}
            blockColor={block_color}
            title={title}
            content={content}
            link={link}
            position={position}
          />
        </ConditionalWrapper>
      </Container>
    </section>
  );
};

export default VideoWayfinder;
